<template>
  <nav
    class="navbar navbar-main navbar-expand-lg px-0 mx-4  m-4 shadow-sm border-radius-xl navbar-custom"
    :class="isRTL ? 'top-0 position-sticky z-index-sticky' : ''"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid text-dark">
      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >
        <div class="d-flex align-items-center" style="flex-grow: 1">
          <div class="input-group pe-md-3" style="max-width: 350px">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Buscar Curso"
            />
          </div>
        </div>
        <ul class="navbar-nav justify-content-end align-items-center">
          <li
            class="nav-item d-flex align-items-center me-4 notification-button"
          >
            <a
              href="#"
              @click="$router.push({ name: 'Calendario' })"
              class="d-flex align-items-center"
            >
              <i class="far fa-calendar me-2"></i>
              <span style="width: 150px">{{ currentDate }}</span>
            </a>
          </li>

          <li
            class="nav-item dropdown d-flex align-items-center me-3 position-relative"
            :class="isRTL ? 'ps-2' : 'pe-2'"
          >
            <a
              href="#"
              class="p-0 nav-link"
              :class="[showMenu ? 'show' : '']"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="toggleMenu"
              @blur="closeMenu"
            >
              <i class="cursor-pointer fa fa-bell"></i>
              <span
                v-if="hayNotificaciones"
                class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
              ></span>
            </a>
            <ul
              class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4"
              :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton"
              style="width: auto; min-width: 300px"
            >
              <li v-if="cargandoNotificaciones" class="text-center">
                <span>Cargando notificaciones...</span>
              </li>

              <li
                v-else
                v-for="notificacion in notificaciones"
                :key="notificacion.id"
                class="mb-2"
              >
                <div class="dropdown-item-custom">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <i class="fa fa-dot-circle" style="color: red"></i>
                        {{ notificacion.tipo }}
                      </h6>
                      <p class="mb-0 text-xs">{{ notificacion.mensaje }}</p>
                      <small class="text-muted">{{
                        notificacion.fecha_envio
                      }}</small>
                    </div>
                  </div>
                  <button
                    class="btn btn-outline-secondary btn-sm"
                    @click="desactivarNotificacion(notificacion)"
                    v-if="notificacion.estado === 1"
                  >
                    Marcar como leído
                  </button>
                </div>
              </li>

              <li
                v-if="!cargandoNotificaciones && notificaciones.length === 0"
                class="text-center"
              >
                <span>No hay notificaciones</span>
              </li>
            </ul>
          </li>

          <li class="nav-item d-flex align-items-center me-3">
            <div class="d-flex flex-column align-items-start">
              <a class="text-dark">{{ user.nombres }}</a>
              <a
                href="#"
                class="text-secondary"
                @click="$router.push({ name: 'PerfilUsuario' })"
                style="font-size: 12px"
                >Ver Perfil</a
              >
            </div>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center me-4">
            <a
              href="#"
              @click="minimizeSidebar"
              class="p-0 nav-link iconNavbarSidenav"
              id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link text-body p-0">
              <div class="bg-warning rounded-circle p-3 bg-warning-custom">
                <i class="fas fa-image text-white"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import notificacionesService from "@/services/NotificacionesService";

const showMenu = ref(false);
const notificaciones = ref([]);
const cargandoNotificaciones = ref(false);

const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const user = JSON.parse(localStorage.getItem("user"));
const usuarioId = user ? user.id_cliente : null;

const minimizeSidebar = () => store.commit("sidebarMinimize");

const closeMenu = () => {
  setTimeout(() => {
    showMenu.value = false;
  }, 100);
};

const currentDate = computed(() => {
  const now = new Date();
  return now.toLocaleString("es-ES", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
});

const fetchNotificaciones = async () => {
  if (!usuarioId) return;

  try {
    cargandoNotificaciones.value = true;
    const response =
      await notificacionesService.getNotificacionesPorUsuario(usuarioId);

    notificaciones.value = response.data.data.map((notificacion) => ({
      id: notificacion.id,
      tipo: notificacion.tipo,
      mensaje: notificacion.mensaje,
      fecha_envio: new Date(notificacion.fecha_envio).toLocaleString("es-ES", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      estado: notificacion.estado,
    }));
  } catch (error) {
    console.error("Error al cargar notificaciones:", error);
  } finally {
    cargandoNotificaciones.value = false;
  }
};

onMounted(() => {
  fetchNotificaciones();
});

const toggleMenu = () => {
  showMenu.value = !showMenu.value;
  if (showMenu.value && notificaciones.value.length === 0) {
    fetchNotificaciones();
  }
};

const desactivarNotificacion = async (notificacion) => {
  try {
    await notificacionesService.desactivar(notificacion.id);
    notificacion.estado = 0;
  } catch (error) {
    console.error("Error al desactivar notificación:", error);
  }
};

const hayNotificaciones = computed(() => {
  return notificaciones.value.some((notificacion) => notificacion.estado === 1);
});
</script>

<style scoped>
.navbar-custom {
  background-color: white;
}

.dropdown-item-custom {
  background-color: white;
  color: black;
  padding: 10px;
  border-radius: 5px;
  word-wrap: break-word;
}

.notification-button {
  margin: 0 auto;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
}

.bg-warning-custom {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
